import { Register } from '@features/ForestOwner/Register'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/register')({
  component: Register,
  staticData: {
    breadcrumb: 'Registrer skogeier',
  },
})
